<template>
	<div>
		<el-row class="crumbs-boxContent" v-if="value==1">
			<!-- 头部 搜索数据 -->
			<el-row>
				<el-row>
					<el-breadcrumb separator-class="el-icon-arrow-right" class="crumbsContent">
						<el-breadcrumb-item>当前位置</el-breadcrumb-item>
						<el-breadcrumb-item>内容管理</el-breadcrumb-item>
						<el-breadcrumb-item>内容查询</el-breadcrumb-item>
					</el-breadcrumb>
				</el-row>
				<el-row class="selectboxContent">
					<el-col :span="2" class="seachTitleContentAdmin">
						渠道分类:
					</el-col>
					<el-col :span="3">
						<select class="selectContent" @change="quValue" v-model="moduleIdList.chnanelTypeName">
							<option value="全部">全部</option>
							<option value="PC">PC</option>
							<option value="M站">M站</option>
						</select>
					</el-col>
					<el-col :span="2" class="seachTitleContentAdmin">
						模块名称:
					</el-col>
					<el-col :span="3">
						<select class="selectContent" @change="moduleOneData">
							<option value="全部">全部</option>
							<option :value="item.moduleName" v-for="item in moduleName">{{item.moduleName}}</option>
						</select>
					</el-col>
					<el-col :span="2" class="seachTitleContentAdmin">
						模块分类:
					</el-col>
					<el-col :span="3">
						<select class="selectContent" @change="moduleTwoData">
							<option value="全部">全部</option>
							<option :value="item.moduleName" v-for="item in moduleClassifyName">{{item.moduleName}}
							</option>
						</select>
					</el-col>
					<el-col :span="2" class="seachTitleContentAdmin">
						模块子分类:
					</el-col>
					<el-col :span="3">
						<select class="selectContent" @change="moduleThreeData">
							<option value="全部">全部</option>
							<option :value="item.moduleName" v-for="item in moduleSonClassifyName">{{item.moduleName}}
							</option>
						</select>
					</el-col>
				</el-row>
				<el-row class="selectboxContent">
					<el-col :span="2" class="seachTitleContentAdmin">
						状态:
					</el-col>
					<el-col :span="3">
						<select class="selectContent" v-model="moduleIdList.statusName" @change="searchStatus">
							<option value="全部">全部</option>
							<option value="0">待发布</option>
							<option value="1">已发布</option>
						</select>
					</el-col>
					<el-col :span="2" class="seachTitleContentAdmin">
						创建人:
					</el-col>
					<el-col :span="3">
						<input type="text" class="selectContent" v-model="moduleIdList.createName">
					</el-col>
					<el-col :span="1" :offset="1">
						<button @click="search" class="searchbtn">查询</button>
					</el-col>
					<el-col :span="1" style="margin-left: 20px;">
						<button @click="reset" class="resetbtn">重置</button>
					</el-col>
				</el-row>
			</el-row>
			<!-- 表格 -->
			<el-row class="formboxContent">
				<el-row class="addbox">
					<el-col :span="3">
						<button class="searchbtn" @click="add">新增</button>
					</el-col>
				</el-row>
				<el-row>
					<div style="overflow-y: scroll;">
						<table class="tableboxContent">
							<tr class="table-firsttitle">
								<td>渠道分类</td>
								<td>模块名称</td>
								<td>模块分类</td>
								<td>模块子名称</td>
								<td>标题</td>
								<td>排序</td>
								<td>状态</td>
								<td>操作时间</td>
								<td>创建时间</td>
								<td>创建人</td>
								<td>操作</td>
							</tr>
							<tr class="table-trtitleContent" v-for="item in list">
								<td>{{item.chnanelTypeName}}</td>
								<td>
									<p class="tableTitle" :title="item.moduleName">
										{{item.moduleName}}
									</p>
								</td>
								<td id="timeBox">
									<p class="tableTitle" :title="item.moduleClassifyName">
										{{item.moduleClassifyName}}
									</p>
								</td>
								<td>
									<p class="tableTitle" :title="item.moduleSonClassifyName">
										{{item.moduleSonClassifyName}}
									</p>
								</td>
								<td id="timeBox">
									<p class="tableTitle" :title="item.title" v-if="item.title">
										{{item.title}}
									</p>
									<p class="tableTitle" :title="item.theaterName" v-else>
										{{item.theaterName}}
									</p>
									<p class="tableTitle" :title="item.leadName" v-if="item.moduleName==='ABOUT'">
										{{item.leadName}}
									</p>
								</td>
								<td>{{item.sort}}</td>
								<td>{{item.statusName}}</td>
								<td id="timeBox">{{item.updateTime}}</td>
								<td id="timeBox">{{item.createTime}}</td>
								<td>
									<p class="tableTitle" :title="item.createName">
										{{item.createName}}
									</p>
								</td>
								<td v-if="item.statusName=='已发布'" @click="soldOut(item)" class="operateColor">
									下架
								</td>
								<td v-else class="operateColor">
									<span @click="edit(item)">编辑</span>
									<span @click="issue(item)">发布</span>
									<span @click="del(item)">删除</span>
								</td>
							</tr>
						</table>
					
					</div>
					<div class="block" style="margin-top: 20px;">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page.sync="currentPage" :page-sizes="[10,20,30]"
							layout="total, sizes, prev, pager, next, jumper" :total="total">
						</el-pagination>
					</div>
				</el-row>
			</el-row>
		</el-row>

		<!-- 新增 & 编辑 -->
		<el-row class="crumbs-boxContent" v-else>
			<!-- 新增 & 编辑头部 -->
			<el-row>
				<el-breadcrumb separator-class="el-icon-arrow-right" class="crumbsContent">
					<el-breadcrumb-item>当前位置</el-breadcrumb-item>
					<el-breadcrumb-item>
						<span @click="content">内容管理</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item>新增内容</el-breadcrumb-item>
				</el-breadcrumb>
			</el-row>
			<el-row class="add-input">
				<el-col :span="2" :offset="1" class="titleContent">
					<span class="must">*</span>模块名称:
				</el-col>
				<el-col :span="5" :offset="1">
					<select class="selectContent" @change="saveModuleOneData" v-model="seletVal">
						<option value="" disabled selected style="display: none;">请选择</option>
						<option v-for="item in moduleName" :value="item.moduleName" :key="item.value">
							{{item.moduleName}}</option>
					</select>
				</el-col>
			</el-row>
			<el-row class="add-input" v-if="istwo">
				<el-col :span="2" :offset="1" class="titleContent">
					<span class="must">*</span>模块分类:
				</el-col>
				<el-col :span="5" :offset="1">
					<select class="selectContent" @change="saveModuleTwoData" v-model="classifyVal">
						<option value="" disabled selected style="display: none;">请选择</option>
						<option v-for="item in moduleClassifyName" :value="item.moduleName" :key="item.value">
							{{item.moduleName}}
							</option>
					</select>
				</el-col>
			</el-row>
			<el-row class="add-input" v-if="isthree">
				<el-col :span="2" :offset="1" class="titleContent">
					<span class="must">*</span>模块子分类:
				</el-col>
				<el-col :span="5" :offset="1">
					<select class="selectContent" @change="saveModuleThreeData" v-model="sonClassifyVal">
						<option value="" disabled selected style="display: none;">请选择</option>
						<option v-for="item in moduleSonClassifyName" :value="item.moduleName" :key="item.value">
							{{item.moduleName}}</option>
					</select>
				</el-col>
			</el-row>
			<!-- <div v-for="item in showformList"> -->
				<!-- 客户端 -->
				<el-row class="add-input" v-if="showformList.includes('chnanelTypeName')">
					<el-col :span="2" :offset="1" class="titleContent">
						<span class="must">*</span>客户端:
					</el-col>
					<el-col :span="5" :offset="1">
						<el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
							<el-checkbox label="PC端" class="kehuPC"></el-checkbox>
							<el-checkbox label="M端" class="kehuM"></el-checkbox>
						</el-checkbox-group>
					</el-col>
				</el-row>
				<!-- 剧院数 -->
				<el-row class="add-input" v-if="showformList.includes('theaterNum')">
					<el-col :span="2" :offset="1" class="titleContent">
						剧院数:
					</el-col>
					<el-col :span="5" :offset="1">
						<input type="text" v-model="saveForm.theaterNum" class="selectContent" maxlength="9999"
							@change="theaterNumCheck">
					</el-col>
				</el-row>
				<!-- 剧目数 -->
				<el-row class="add-input" v-if="showformList.includes('repertoryNum')">
					<el-col :span="2" :offset="1" class="titleContent">
						<span class="must">*</span>剧目数:
					</el-col>
					<el-col :span="5" :offset="1">
						<input type="text" v-model="saveForm.repertoryNum" class="selectContent" maxlength="1000">
					</el-col>
				</el-row>
				<!-- 观众数 -->
				<el-row class="add-input" v-if="showformList.includes('viewerNum')">
					<el-col :span="2" :offset="1" class="titleContent">
						<span class="must">*</span>观众数:
					</el-col>
					<el-col :span="5" :offset="1">
						<input type="text" v-model="saveForm.viewerNum" class="selectContent" maxlength="1000">
					</el-col>
				</el-row>
				<!-- 标题 -->
				<el-row class="add-input" v-if="showformList.includes('title')">
					<el-col :span="2" :offset="1" class="titleContent">
						<span class="must" v-if="isTitleMust">*</span>标题:
					</el-col>
					<el-col :span="5" :offset="1">
						<input type="text" v-model="saveForm.title" class="selectContent" maxlength="300">
					</el-col>
				</el-row>
				<!-- 领导姓名 -->
				<el-row class="add-input" v-if="showformList.includes('leadName')">
					<el-col :span="2" :offset="1" class="titleContent">
						<span class="must">*</span>领导姓名:
					</el-col>
					<el-col :span="5" :offset="1">
						<input type="text" v-model="saveForm.leadName" class="selectContent" maxlength="100">
					</el-col>
				</el-row>
				<!-- 领导职位 -->
				<el-row class="add-input" v-if="showformList.includes('leadPost')">
					<el-col :span="2" :offset="1" class="titleContent">
						<span class="must">*</span>领导职位:
					</el-col>
					<el-col :span="6" :offset="1">
						<el-row v-for="(ele,idx) in leadPostList" :key="idx" style="margin-bottom:10px">
							<el-col :span="20">
									<input type="text" v-model="ele.value" class="selectContent" maxlength="500"/>
							</el-col>
							<el-col :span="2" :offset="2">
								<i class="el-icon-remove eleIconStyle" @click="updateLeadPostList('remove',idx)" v-if="idx!==0"></i>
							</el-col>
						</el-row>
						<el-row>
							<div class="addLeadPostBtn" @click="updateLeadPostList('add')">
								<i class="el-icon-circle-plus-outline eleIconStyle"></i>添加职位
							</div>
						</el-row>
					</el-col>
				</el-row>
				<!-- 排序 -->
				<el-row class="add-input" v-if="showformList.includes('sort')">
					<el-col :span="2" :offset="1" class="titleContent">
						<span class="must">*</span>排序:
					</el-col>
					<el-col :span="5" :offset="1">
						<input type="text" v-model="saveForm.sort" class="selectContent" maxlength="200">
					</el-col>
				</el-row>
				<!-- 剧院名称 -->
				<el-row class="add-input" v-if="showformList.includes('theaterName')">
					<el-col :span="2" :offset="1" class="titleContent">
						<span class="must">*</span>剧院名称:
					</el-col>
					<el-col :span="5" :offset="1">
						<input type="text" v-model="saveForm.theaterName" class="selectContent" maxlength="200">
					</el-col>
				</el-row>
				<!-- 邮箱 -->
				<el-row class="add-input" v-if="showformList.includes('email')">
					<el-col :span="2" :offset="1" class="titleContent">
						<span class="must">*</span>邮箱:
					</el-col>
					<el-col :span="5" :offset="1">
						<input type="text" v-model="saveForm.email" class="selectContent" maxlength="200">
					</el-col>
				</el-row>
				<!-- 联系方式 -->
				<el-row class="add-input" v-if="showformList.includes('tell')">
					<el-col :span="2" :offset="1" class="titleContent">
						<span class="must">*</span>联系方式:
					</el-col>
					<el-col :span="5" :offset="1">
						<input type="text" v-model="saveForm.tell" class="selectContent" maxlength="100">
					</el-col>
				</el-row>
				<!-- 地址 -->
				<el-row class="add-input" v-if="showformList.includes('adress')">
					<el-col :span="2" :offset="1" class="titleContent">
						<span class="must">*</span>地址:
					</el-col>
					<el-col :span="5" :offset="1">
						<input type="text" v-model="saveForm.adress" class="selectContent" maxlength="200">
					</el-col>
				</el-row>
				<!-- 图片 -->
				<el-row class="add-input" v-if="showformList.includes('pictureUrl')">
					<!-- 判断图片是否是THEATRES 多张图片 -->
					<el-row v-if="imgMore==false">
						<el-col :span="2" :offset="1" class="titleContent">
							<span class="must" v-if="isTitleMust">*</span>图片:
						</el-col>
						<el-col :span="10" :offset="1">
							<el-upload action="/api/upload" list-type="picture-card" :on-success="successMore"
							:file-list="fileList"
							:before-upload="beforeAvatarUpload" :on-remove="beforeTheatreremove" :limit="1"
							style="float:left">
							<i class="el-icon-plus"></i>
							</el-upload>
						</el-col>
					</el-row>
					<!-- THEATRES  多张图片 -->
					<el-row v-else>
						<el-col :span="2" :offset="1" class="titleContent">
							<span class="must">*</span>图片:
						</el-col>
						<!-- 添加 -->
						<el-col :span="20" :offset="1">
							<el-upload action="/api/upload" list-type="picture-card" :on-success="successMore"
							:file-list="fileList"
							:on-exceed="onExceed"
								:before-upload="beforeAvatarUpload" :on-remove="beforeTheatreremove" :limit="5"
								style="float: left;">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-col>
					</el-row>
					<el-row class="sizeContent">
						<el-col :span="20" :offset="4" v-if="imgType=='bresaking'">
							尺寸：320px*240px 大小：500MB
						</el-col>
						<el-col :span="20" :offset="4" v-else-if="imgType=='what'">
							尺寸：370px*421px 大小：500MB
						</el-col>
						<el-col :span="20" :offset="4" v-else-if="imgType=='message' || imgType=='leadership'">
							尺寸：375px*500px 大小：500MB
						</el-col>
						<el-col :span="20" :offset="4" v-else-if="imgType=='performances' || imgType=='outreach'">
							尺寸：520px*454px 大小：500MB
						</el-col>
						<el-col :span="20" :offset="4" v-else-if="imgType=='highlights'">
							尺寸：560px*315px 大小：500MB
						</el-col>
						<el-col :span="20" :offset="4" v-else-if="imgType=='seasonal' || imgType=='poly'">
							尺寸：570px*428px 大小：500MB
						</el-col>
						<el-col :span="20" :offset="4" v-else-if="imgType=='landmark'">
							尺寸：800px*450px 大小：500MB
						</el-col>
						<el-col :span="20" :offset="4" v-else-if="imgType=='co' || imgType=='education'">
							尺寸：1100px*480px 大小：500MB
						</el-col>
						<el-col :span="20" :offset="4" v-else-if="imgType=='polyArts'">
							尺寸：1100px*428px 大小：500MB
						</el-col>
					</el-row>
				</el-row>
				<!-- 发布时间 -->
				<el-row class="add-input" v-if="showformList.includes('publishTime')">
					<el-col :span="2" :offset="1" class="titleContent">
						<span class="must" v-if="isTimeMust">*</span>发布时间:
					</el-col>
					<el-col :span="5" :offset="1">
						<el-date-picker v-model="saveForm.publishTime" type="datetime" placeholder="选择日期时间"
							value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
					</el-col>
				</el-row>
				<!-- 是否推荐 -->
				<el-row class="add-input" v-if="showformList.includes('isRecommend')">
					<el-col :span="2" :offset="1" class="titleContent">
						<span class="must">*</span>是否推荐:
					</el-col>
					<el-col :span="5" :offset="1">
						<el-radio v-model="radio" value="是" label="1" @change="radioData" class="isnoPC">是</el-radio>
						<el-radio v-model="radio" value="否" label="0" @change="radioData" class="isnoM">否</el-radio>
					</el-col>
				</el-row>
				<!-- 正文内容 -->
				<el-row class="bodyContentInput" v-if="showformList.includes('bodyContent')">
					<el-col :span="2" :offset="1" class="titleContent">
						<span class="must">*</span>正文内容:
					</el-col>
					<el-col :span="20" :offset="1" style="height: 500px;">
						<quill-editor v-model="saveForm.bodyContent" @change="quill($event)" :options="editorOption"
							ref="QuillEditor" style="background-color: white;height: 400px;padding-bottom: 65px;"></quill-editor>
					</el-col>
				</el-row>
				<el-row v-if="showformList.includes('bodyContent')">
					<el-col :span="20" :offset="4" class="htmlContent">
						<span :class="[htmlLengthOver==false?'htmlLengthOverFalse':'htmlLengthOverTrue']"
						v-if="item=='bodyContent'">{{htmlLength}}</span>/10000
					</el-col>
				</el-row>

				<el-row>
					<!-- 图片上传组件辅助-->
					<el-upload class="avatar-uploader" action="/api/upload" name="file" :show-file-list="false"
						:on-success="uploadSuccess">
					</el-upload>
				</el-row>
			<!-- </div> -->

			<el-row class="add-input">
				<el-col :span="1" :offset="4">
					<button @click="saveBtn" class="savebtn">保存</button>
				</el-col>
				<el-col :span="1" style="margin-left: 20px">
					<button @click="cancel" class="savebtn">取消</button>
				</el-col>
			</el-row>
		</el-row>
	</div>
</template>

<script>
	import {
		quillEditor
	} from 'vue-quill-editor'
	import 'quill/dist/quill.core.css';
	import 'quill/dist/quill.snow.css';
	import 'quill/dist/quill.bubble.css';

	const toolbarOptions = [
		['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
		['blockquote', 'code-block'], //引用，代码块
		[{
			'header': 1
		}, {
			'header': 2
		}], // 几级标题
		[{
			'list': 'ordered'
		}, {
			'list': 'bullet'
		}], // 有序列表，无序列表
		[{
			'script': 'sub'
		}, {
			'script': 'super'
		}], // 下角标，上角标
		[{
			'indent': '-1'
		}, {
			'indent': '+1'
		}], // 缩进
		[{
			'direction': 'rtl'
		}], // 文字输入方向
		[{
			'size': ['small', false, 'large', 'huge']
		}], // 字体大小
		[{
			'header': [1, 2, 3, 4, 5, 6, false]
		}], // 标题
		[{
			'color': []
		}, {
			'background': []
		}], // 颜色选择
		[{
			'font': ['SimSun', 'SimHei', 'Microsoft-YaHei', 'KaiTi', 'FangSong', 'Arial']
		}], // 字体
		[{
			'align': []
		}], // 居中
		['clean'], // 清除样式,
		['link', 'image', 'upload'], // 上传图片、上传视频
	]
	import {
		contentList, //列表
		deleteContent, //删除
		updateContentStatus, // 修改发布下架状态
		moduleList, // 模块
		selectContentById,
		editContent //编辑 & 保存
	} from '@/api/index.js'
	export default {
		data() {
			return {
				list: [],

				// 显示页面
				value: 1,

				// 总共页数
				page: 1,
				// 每页条数
				pageSize: 10,
				// 当前页数
				currentPage: 1,
				// 总条数
				total: 0,

				// 一级数据名字
				moduleName: [],
				// 二级数据名字
				moduleClassifyName: [],
				// 三级数据名字
				moduleSonClassifyName: [],

				moduleIdList: {
					chnanelType: '',
					chnanelTypeName: '全部',
					createName: '',
					moduleName: '',
					moduleClassifyName: '',
					moduleSonClassifyName: '',
					status: '',
					statusName: '全部'
				},

				checkList: ['PC端', 'M端'],

				// 图片
				dialogImageUrl: '',
				dialogVisible: false,

				radio: '1',
				leadPostList:[{value:''}],
				saveForm: {},


				seletVal: '',
				classifyVal: '',
				sonClassifyVal: '',
				showList: ['chnanelTypeName', 'theaterNum', 'repertoryNum', 'viewerNum', 'title', 'leadName', 'leadPost',
					'sort', 'theaterName', 'email', 'tell', 'adress', 'prctureUrl', 'publishTime', 'isRecommend',
					'bodyContent'
				],
				showformList: [],

				imgType: '',

				imgMore: false,
				img: [],

				// 长度
				htmlLength: 0,
				htmlLengthOver: false,

				editorOption: {
					placeholder: '请在这里输入',
					theme: 'snow', //主题 snow/bubble
					modules: {
						history: {
							delay: 1000,
							maxStack: 50,
							userOnly: false
						},
						toolbar: {
							container: toolbarOptions,
							handlers: {
								image: function(value) {
									if (value) {
										// 调用element的图片上传组件
										document.querySelector('.avatar-uploader input').click()
									} else {
										this.quill.format('image', false)
									}
								},
							}
						}
					}
				},

				qcontent: {},

				iselUpload: false,
				id: 0,

				move: false,
				
				
				// 测试图片
				fileList:[],
				disabled:false,
				
				istwo:true,
				isthree:true,
				
				isTitleMust:true,
				isTimeMust:true,
				
				isTheaterName:false,
			}
		},
		created() {
			this.getList();
			this.moduleData();
		},
		methods: {
			// 获取内容数据
			getList() {
				contentList({
						page: this.page,
						pageSize: this.pageSize,
						chnanelType: this.moduleIdList.chnanelType,
						status: this.moduleIdList.status,
						createName: this.moduleIdList.createName,
						moduleNameId: this.moduleIdList.moduleName,
						moduleClassifyId: this.moduleIdList.moduleClassifyName,
						moduleSonClassifyId: this.moduleIdList.moduleSonClassifyName
					})
					.then((response) => {
						this.currentPage = response.data.data.current;
						this.pageSize = response.data.data.size;
						this.list = response.data.data.records;
						this.total = response.data.data.total;
						this.list.map((v)=>
						{
							if(v.title==null)
							{
								console.log(v,111)
							}
						})
					})
			},
			// 重新刷新数据
			resetList() {
				this.page = 1;
				this.pageSize = 10;
				this.getList()
			},
			// 内容管理
			content() {
				this.value = 1;
			},
			// 当前条数
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.getList()
			},
			// 当前页数
			handleCurrentChange(val) {
				this.page = val;
				this.getList()
			},
			quValue(e) {
				if (e.currentTarget.value == 'PC') {
					this.moduleIdList.chnanelType = 1
				} else if (e.currentTarget.value == 'M站') {
					this.moduleIdList.chnanelType = 2
				} else {
					this.moduleIdList.chnanelType = ''
				}
			},
			add() {
				this.moduleName = [];
				this.moduleClassifyName = [];
				this.moduleSonClassifyName = []
				this.showformList = [];
				this.fileList=[];
				this.moduleData();
				this.seletVal = '';
				this.classifyVal = '';
				this.sonClassifyVal = '';
				this.saveForm = {};
				this.value = 2;
				this.htmlLength = 0;
				this.id = 0;
				this.istwo=true;
				this.isthree=true;
				this.isTitleMust=true;
				this.isTimeMust=true;
				this.htmlLengthOver=false;
			},
			// 删除
			del(item) {
				this.$confirm('是否删除数据?', '删除数据', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						deleteContent({
								data: item
							})
							.then((response) => {
								this.resetList()
								this.$message.success('删除成功')
							})
					})
					.catch(() => {
						this.$message.info('已取消删除')
						return false;
					})
			},
			// 下架
			soldOut(item) {
				console.log(this.page,1)
				if (item.status == 1) {
					item.status = 0;
				}
				updateContentStatus({
						data: item
					})
					.then((response) => {
						console.log(this.page)
						this.getList()
					})
			},
			// 发布
			issue(item) {
				if (item.status == 0) {
					item.status = 1;
				}
				updateContentStatus({
						data: item
					})
					.then((response) => {
						this.getList()
					})
			},

			// 获取一级数据
			moduleData() {
				moduleList({
						moduleId: 0
					})
					.then((response) => {
						this.moduleName = response.data.data;
					})
						console.log(this.moduleClassifyName,222)
			},
			// 点击一级
			moduleOneData(e) {
				this.moduleClassifyName = [];
				this.moduleSonClassifyName = [];
				this.moduleIdList = [];
				this.moduleIdList.chnanelTypeName = '全部',
				this.moduleIdList.statusName = '全部',
				this.moduleIdList.moduleName = '';
				this.moduleName.map((v) => {
					if (v.moduleName == e.currentTarget.value) {
						moduleList({
								moduleId: v.moduleId
							})
							.then((response) => {
								this.moduleIdList.moduleName = v.moduleId;
								this.moduleClassifyName = response.data.data;
								console.log(this.moduleClassifyName,'二级数据')
							})
					}
				})
			},
			// 点击二级 获取三级数据
			moduleTwoData(e) {
				this.moduleSonClassifyName = [];
				this.moduleIdList.moduleClassifyName = '';
				this.moduleClassifyName.map((v) => {
					if (v.moduleName == e.currentTarget.value) {
						moduleList({
								moduleId: v.moduleId
							})
							.then((response) => {
								this.moduleIdList.moduleClassifyName = v.moduleId;
								this.moduleSonClassifyName = response.data.data;
							})
					}
				})
			},
			// 点击三级
			moduleThreeData(e) {
				this.moduleIdList.moduleSonClassifyName = '';
				this.moduleSonClassifyName.map((v) => {
					if (v.moduleName == e.currentTarget.value) {
						moduleList({
								moduleId: v.moduleId
							})
							.then((response) => {
								this.moduleIdList.moduleSonClassifyName = v.moduleId;
							})
					}
				})
			},
			// 已发布未发布
			searchStatus(e) {
				if(e.currentTarget.value=='全部')
				{
					this.moduleIdList.status=''
				}
				else
				{
					this.moduleIdList.status = e.currentTarget.value;
				}
			},
			// 搜索
			search() {
				console.log(this.moduleIdList,'总体')
				console.log(this.moduleIdList.status,'单个')
				contentList({
						page: 1,
						pageSize: 10,
						chnanelType: this.moduleIdList.chnanelType,
						moduleNameId: this.moduleIdList.moduleName,
						status: this.moduleIdList.status,
						createName: this.moduleIdList.createName,
						moduleClassifyId: this.moduleIdList.moduleClassifyName,
						moduleSonClassifyId: this.moduleIdList.moduleSonClassifyName
					})
					.then((response) => {
						if (response.data.data.records.length < 1) {
							this.open()
							this.resetList()
						} else {
							this.currentPage = response.data.data.current;
							this.pageSize = response.data.data.size;
							this.list = response.data.data.records;
							this.total = response.data.data.total;
						}
					})
			},
			// 重置
			reset() {
				this.moduleIdList = {};
				this.moduleIdList.chnanelTypeName = '全部',
				this.moduleIdList.statusName = '全部',
				this.moduleName = [];
				this.moduleClassifyName = [];
				this.moduleSonClassifyName = [];
				this.moduleData();
				this.resetList()
			},
			// 没有数据
			open() {
				this.$alert('请查看是否输入正确', '没有找到相关数据', {
					confirmButtonText: '确定',
				});
			},

			// 编辑
			edit(item) {
				console.log(item,'编辑的单独数据')
				this.isTitleMust=true;
				this.isTimeMust=true;
				this.istwo=true;
				this.isthree=true;
				this.fileList=[];
				if (item.moduleNameId == 3) {
					this.imgMore = true;
				}
				this.moduleClassifyName = [];
				this.moduleSonClassifyName = [];
				this.seletVal = item.moduleName;
				this.classifyVal = item.moduleClassifyName;
				this.sonClassifyVal = item.moduleSonClassifyName;
				// 三级有数据
				if (this.sonClassifyVal != null) {
					console.log('三级有数据')
					moduleList({
							moduleId: item.moduleClassifyId
						})
						.then((response) => {
							this.moduleSonClassifyName = response.data.data;
						})
					moduleList({
							moduleId: item.moduleNameId
						})
						.then((response) => {
							this.moduleClassifyName = response.data.data;
						})
				}
				// 三级没有数据
				else {
					console.log('三级没有数据')
					this.isthree=false;
					// 二级有数据
					if (this.classifyVal != null) {
					console.log('二级有数据')
						moduleList({
								moduleId: item.moduleClassifyId
							})
							.then((response) => {
								this.moduleClassifyName = response.data.data;
							})
						moduleList({
								moduleId: item.moduleNameId
							})
							.then((response) => {
								this.moduleClassifyName = response.data.data;
							})
					} else {
						console.log('二级没有数据')
						this.istwo=false;
					}
				}
				this.value = 3;
				console.log(item.moduleId,item.moduleSonClassifyId,'item.moduleId item.moduleSonClassifyId')
				console.log(item.moduleId,item.moduleClassifyId,'item.moduleId item.moduleClassifyId')
				console.log(item.moduleId,item.moduleNameId,'item.moduleId item.moduleName')
				if (item.moduleSonClassifyId && item.moduleId == item.moduleSonClassifyId) {
					if (item.moduleSonClassifyName == 'Concert' || item.moduleSonClassifyName == 'Theatre' || item
						.moduleSonClassifyName == 'Ballet And Dance' || item.moduleSonClassifyName ==
						'Opera And Chinese Traditional Opera' || item.moduleSonClassifyName == 'Musical') {
						this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
							'bodyContent'
						]
					}
				} else if (item.moduleId == item.moduleClassifyId) {
					if (item.moduleClassifyName == 'NEWS' || item.moduleClassifyName == 'Theatres' || item
						.moduleClassifyName == 'Featured Evenas') {
						this.showformList = []
					} else if (item.moduleClassifyName == 'Notices') {
						this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'bodyContent']
					} else if (item.moduleClassifyName == 'Who we are') {
						this.showformList = ['chnanelTypeName', 'theaterNum', 'repertoryNum', 'viewerNum', 'title',
							'bodyContent'
						]
					} else if (item.moduleClassifyName == 'What`s On') {
						this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
							'bodyContent'
						]
					} else if (item.moduleClassifyName == "Chair's Message") {
						this.showformList = ['chnanelTypeName', 'leadName', 'leadPost', 'pictureUrl', 'bodyContent']
					} else if (item.moduleClassifyName == 'Executives') {
						this.showformList = ['chnanelTypeName', 'leadName', 'leadPost', 'sort', 'pictureUrl']
					} else if (item.moduleClassifyName == 'Values') {
						this.showformList = ['chnanelTypeName', 'title', 'bodyContent']
					} else if (item.moduleClassifyName == 'Flagship Theatres' || item.moduleClassifyName == 'Eastern China' ||
						item.moduleClassifyName == 'Southern  China' || item.moduleClassifyName == 'Central  China' || item
						.moduleClassifyName == 'Northern  China') {
						this.showformList = ['chnanelTypeName', 'sort', 'theaterName', 'pictureUrl', 'isRecommend',
							'bodyContent'
						]
					} else if (item.moduleClassifyName == 'Seasonal Signature') {
						this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'bodyContent']
					} else if (item.moduleClassifyName == 'Performances') {
						this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
							'bodyContent'
						]
					} else if (item.moduleClassifyName == 'education & outreach') {
						this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'bodyContent']
					} else if (item.moduleClassifyName == 'Education' || item.moduleClassifyName == 'Outreach') {
						this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
							'bodyContent'
						]
					} else if (item.moduleClassifyName == 'Highlights') {
						this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'isRecommend', 'bodyContent']
					} else if (item.moduleClassifyName == 'Performances') {
						this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
							'bodyContent'
						]
					} else if (item.moduleClassifyName == 'International Collaborations') {
						this.showformList = ['chnanelTypeName', 'title', 'publishTime', 'bodyContent']
					} else if (item.moduleClassifyName == 'International Theatre Forum') {
						this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
							'bodyContent'
						]
					} else if (item.moduleClassifyName == 'International Alliance') {
						this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
							'bodyContent'
						]
					} else if(item.moduleClassifyName == 'Strategic Collaborations'){
						this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
							'bodyContent'
						]
					}
				} else {
					if (item.moduleName == 'HOME') {
						this.showformList = []
					} else if (item.moduleName == 'ABOUT') {
						this.showformList = ['chnanelTypeName', 'theaterNum', 'repertoryNum', 'viewerNum', 'title',
							'bodyContent'
						]
					} else if (item.moduleName == 'THEATRES') {
						this.showformList = ['chnanelTypeName', 'sort', 'theaterName', 'pictureUrl', 'isRecommend',
							'bodyContent'
						]
					} else if (item.moduleName == 'PRODUCTIONS') {
						this.showformList = ['chnanelTypeName', 'title', 'sort', 'pictureUrl', 'publishTime',
							'bodyContent']
					} else if (item.moduleName == 'PROGRAMS') {
						this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'bodyContent']
					} else if (item.moduleName == 'EDUCATION&OUTREACH') {
						this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'bodyContent']
					} else if (item.moduleName == 'TICKETING') {
						this.showformList = ['chnanelTypeName', 'title', 'bodyContent']
					} else if (item.moduleName == 'INTERNATIONAL CLLABORATIONS') {
						this.showformList = ['chnanelTypeName', 'title', 'publishTime', 'bodyContent']
					} else if (item.moduleName == 'CONTACT') {
						this.showformList = ['chnanelTypeName', 'email', 'tell', 'adress']
					}
				}

				selectContentById({
						id: item.id
					})
					.then((response) => {
						this.saveForm = response.data.data;
						this.leadPostList = []
						response.data.data.leadPost.split(',').forEach(element => {
							this.leadPostList.push({value:element})
						});
						console.log(this.saveForm,'saveForm')
						this.radio = this.saveForm.isRecommend;
						var length = 0;
						if (this.saveForm.pictureUrl) {
							this.fileList.push({url:this.saveForm.pictureUrl})
							this.saveForm.pictureUrl='';
						}
						if (this.saveForm.pictureUrl2) {
							this.fileList.push({url:this.saveForm.pictureUrl2})
							this.saveForm.pictureUrl2='';
						}
						if (this.saveForm.pictureUrl3) {
							this.fileList.push({url:this.saveForm.pictureUrl3})
							this.saveForm.pictureUrl3='';
						}
						if (this.saveForm.pictureUrl4) {
							this.fileList.push({url:this.saveForm.pictureUrl4})
							this.saveForm.pictureUrl4='';
						}
						if (this.saveForm.pictureUrl5) {
							this.fileList.push({url:this.saveForm.pictureUrl5})
							this.saveForm.pictureUrl5='';
						}
					})
			},

			// 客户端多选框
			handleCheckedCitiesChange(value) {
				if (value.length == 1) {
					if (value == 'PC端') {
						this.saveForm.chnanelType = 1;
						this.saveForm.chnanelTypeName = value.join(',');
					} else {
						this.saveForm.chnanelType = 2;
						this.saveForm.chnanelTypeName = value.join(',');
					}
				} else if (value.length > 1) {
					this.saveForm.chnanelType = '1,2'
					this.saveForm.chnanelTypeName = value.join(',');
				} else {
					this.saveForm.chnanelTypeName = '';
				}
			},
			// 上传图片
			success(file) {
				if (file.data == null) {
					this.saveForm.pictureUrl = undefined;
					return false;
				}
				this.saveForm.pictureUrl = file.data;
			},
			//添加多个领导职称
			updateLeadPostList(type,idx){
				if(type==='add'){
					this.leadPostList.push({value:''})
				} else{
					this.leadPostList.splice(idx,1)
				}
				
			},
			// 添加上传
			successMore(file) {
				this.fileList.push({url:file.data})
			},
			// 判断图片格式
			beforeAvatarUpload(file) {
				this.move = false;
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 500;

				if (!isJPG && !isPNG) {
					this.$message.error('上传图片只能是 JPG,PNG,JPEG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 500MB!');
				}
				return isJPG || isPNG && isLt2M;
				
				console.log(this.img,'img')
			},
			beforeTheatreremove(file) {
				
				for(var i=0;i<this.fileList.length;i++)
				{
					if(this.fileList[i].uid===file.uid)
					{
						this.fileList.splice(i,1)
					}
				}
			},
			// 点击一级
			saveModuleOneData(e) {
				this.classifyVal=''
				this.sonClassifyVal=''
				this.isTitleMust=true;
				this.isTimeMust=true;
				this.istwo=true;
				this.isthree=false;
				this.imgMore = false;
				this.moduleClassifyName = [];
				this.moduleSonClassifyName = [];
				this.saveForm.moduleClassifyId='';
				this.saveForm.moduleClassifyName='';
				this.saveForm.moduleSonClassifyId='';
				this.saveForm.moduleSonClassifyName='';
				if (e.currentTarget.value == 'HOME') {
					this.showformList = []
				} else if (e.currentTarget.value == 'ABOUT') {
					this.showformList = ['chnanelTypeName', 'theaterNum', 'repertoryNum', 'viewerNum', 'title',
						'bodyContent'
					]
				} else if (e.currentTarget.value == 'THEATRES') {
					this.imgMore = true;
					this.img = [];
					this.imgType='landmark';
					this.showformList = ['chnanelTypeName', 'sort', 'theaterName', 'pictureUrl', 'isRecommend',
						'bodyContent'
					]
				} else if (e.currentTarget.value == 'PRODUCTIONS') {
					this.isTimeMust=false;
					this.imgType='co';
					this.showformList = ['chnanelTypeName', 'title', 'sort', 'pictureUrl', 'publishTime', 'bodyContent']
				} else if (e.currentTarget.value == 'PROGRAMS') {
					this.isthree=true;
					this.imgType='seasonal';
					this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'bodyContent']
				} else if (e.currentTarget.value == 'EDUCATION&OUTREACH') {
					this.imgType='education';
					this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'bodyContent']
				} else if (e.currentTarget.value == 'TICKETING') {
					this.showformList = ['chnanelTypeName', 'title', 'bodyContent']
				} else if (e.currentTarget.value == 'INTERNATIONAL CLLABORATIONS') {
					this.showformList = ['chnanelTypeName', 'title', 'publishTime', 'bodyContent']
				} else if (e.currentTarget.value == 'CONTACT') {
					this.showformList = ['chnanelTypeName', 'email', 'tell', 'adress']
				}

				this.moduleName.map((v) => {
					if (v.moduleName == e.currentTarget.value) {
						this.saveForm.moduleNameId = v.moduleId;
						this.saveForm.moduleName = e.currentTarget.value;
						moduleList({
							moduleId: v.moduleId
						})
						.then((response) => {
							this.moduleClassifyName = response.data.data;
							console.log(this.moduleClassifyName, '二级')
							if(this.moduleClassifyName.length==0)
							{
								this.istwo=false;
							}
							else
							{
								this.istwo=true;
							}
						})
					}
				})
			},
			// 点击二级 获取三级数据
			saveModuleTwoData(e) {
				this.sonClassifyVal=''
				this.isTitleMust=true;
				this.isTimeMust=true;
				this.isthree=false;
				this.moduleSonClassifyName = [];
				console.log(e.currentTarget.value,111)
				if (e.currentTarget.value == 'NEWS' || e.currentTarget.value == 'Theatres' || e.currentTarget.value ==
					'Featured Evenas') {
					this.showformList = []
				} else if (e.currentTarget.value == 'Notices') {
					this.imgType = 'bresaking';
					this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'bodyContent']
				} else if (e.currentTarget.value == 'Who we are') {
					this.showformList = ['chnanelTypeName', 'theaterNum', 'repertoryNum', 'viewerNum', 'title',
						'bodyContent'
					]
				} else if (e.currentTarget.value == 'What`s On') {
					this.imgType = 'what';
					this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
						'bodyContent'
					]
				} else if (e.currentTarget.value == "Chair's Message") {
					this.imgType = 'message';
					this.showformList = ['chnanelTypeName', 'leadName', 'leadPost', 'pictureUrl', 'bodyContent']
				} else if (e.currentTarget.value == 'Executives') {
					this.isTitleMust=false;
					this.imgType = 'message';
					this.showformList = ['chnanelTypeName', 'leadName', 'leadPost', 'sort', 'pictureUrl']
				} else if (e.currentTarget.value == 'Values') {
					this.showformList = ['chnanelTypeName', 'title', 'bodyContent']
				} else if (e.currentTarget.value == 'Flagship Theatres' || e.currentTarget.value == 'Eastern China' || e
					.currentTarget.value == 'Southern  China' || e.currentTarget.value == 'Central  China' || e.currentTarget
					.value == 'Northern  China') {
					this.imgType = 'landmark';
					this.showformList = ['chnanelTypeName', 'sort', 'theaterName', 'pictureUrl', 'isRecommend',
						'bodyContent'
					]
				} else if (e.currentTarget.value == 'Seasonal Signature') {
					this.imgType = 'seasonal';
					this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'bodyContent']
				}  else if (e.currentTarget.value == 'Highlights') {
					this.imgType = 'highlights';
					this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'isRecommend', 'bodyContent']
				} else if (e.currentTarget.value == 'Performances') {
					this.isthree=true;
					this.imgType = 'performances';
					this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
						'bodyContent'
					]
				} else if (e.currentTarget.value == 'education & outreach') {
					this.imgType = 'education';
					this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'bodyContent']
				} else if (e.currentTarget.value == 'Education' || e.currentTarget.value == 'Outreach') {
					this.imgType = 'outreach';
					this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
						'bodyContent'
					]
				} else if (e.currentTarget.value == 'International Collaborations') {
					this.showformList = ['chnanelTypeName', 'title', 'publishTime', 'bodyContent']
				} else if (e.currentTarget.value == 'International Theatre Forum') {
					this.imgType = 'poly';
					this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
						'bodyContent'
					]
				} else if (e.currentTarget.value == 'International Alliance') {
					this.imgType = 'polyArts';
					this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
						'bodyContent'
					]
				} else if (e.currentTarget.value == 'Strategic Collaborations') {
					this.imgType = 'poly';
					this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
						'bodyContent'
					]
				} 


				this.moduleClassifyName.map((v) => {
					if (v.moduleName == e.currentTarget.value) {
						this.saveForm.moduleClassifyId = v.moduleId;
						this.saveForm.moduleClassifyName = e.currentTarget.value;
						moduleList({
							moduleId: v.moduleId
						})
						.then((response) => {
							this.moduleSonClassifyName = response.data.data;
							console.log(this.moduleSonClassifyName,'三级')
							if(this.moduleSonClassifyName.length==0)
							{
								this.isthree=false;
							}
							else
							{
								this.isthree=true;
							}
						})
					}
				})
			},
			// 点击三级
			saveModuleThreeData(e) {
				this.isTitleMust=true;
				this.isTimeMust=true;
				console.log(e.currentTarget.value,333)
				if (e.currentTarget.value == 'Concert' || e.currentTarget.value == 'Theatre' || e.currentTarget.value ==
					'Ballet And Dance' || e.currentTarget.value == 'Opera And Chinese Traditional Opera' || e.currentTarget.value == 'Musical') {
						console.log(111)
					this.showformList = ['chnanelTypeName', 'title', 'pictureUrl', 'publishTime', 'isRecommend',
						'bodyContent'
					]
				}

				this.moduleSonClassifyName.map((v) => {
					if (v.moduleName == e.currentTarget.value) {
						this.saveForm.moduleSonClassifyId = v.moduleId;
						this.saveForm.moduleSonClassifyName = e.currentTarget.value;
					}
				})
			},
			radioData(e) {
				this.saveForm.isRecommend = e;
			},
			// 保存
			saveBtn() {
				// todo
				// 处理领导职位
				const postArr = this.leadPostList.map(ele=>ele.value)
				postArr[0] ? this.saveForm.leadPost = postArr.join(',') : this.saveForm.leadPost = ''
				if (this.moduleSonClassifyName == []) {
					this.saveForm.moduleSonClassifyId = undefined;
					this.saveForm.moduleSonClassifyName = '';
				}
				if (this.moduleClassifyName == []) {
					this.saveForm.moduleClassifyId = undefined;
					this.saveForm.moduleClassifyName = '';
				}
				if (this.saveForm.moduleSonClassifyId == undefined || this.saveForm.moduleSonClassifyId == '') {
					if (this.saveForm.moduleClassifyId == undefined|| this.saveForm.moduleClassifyId == '') {
						this.saveForm.moduleId = this.saveForm.moduleNameId;
					} else {
						this.saveForm.moduleId = this.saveForm.moduleClassifyId;
					}
				} else {
					this.saveForm.moduleId = this.saveForm.moduleSonClassifyId;
				}
				if (this.saveForm.isRecommend == undefined) {
					this.saveForm.isRecommend = this.radio;
				}
				if (this.saveForm.chnanelTypeName == undefined) {
					this.saveForm.chnanelTypeName = this.checkList.join(',');
					this.saveForm.chnanelType = '1,2';
				}
				if (this.saveForm.chnanelTypeName == '') {
					this.saveForm.chnanelTypeName = '';
					this.saveForm.chnanelType = '';
					this.$message.error('客户端未填写，请完整填写信息后提交')
					return false;
				}

				console.log(this.img)


				this.verufy();
				if (this.saveForm.email != undefined) {
					const reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
					if (!reg.test(this.saveForm.email)) {
						this.$message.error('邮箱格式输入错误')
						return false;
					}
				}
				if (this.saveForm.theaterNum > 9999) {
					this.$message.error('最大字符数为99999，请填写正确后提交')
					return false;
				}
				// 图片
				for(var i=1;i<=this.fileList.length;i++)
				{
					console.log(this.fileList[i-1],'1387')
					if(i==1)
					{
						this.saveForm.pictureUrl = this.fileList[i-1].url;
					}
					else
					{
						this.saveForm['pictureUrl'+i] = this.fileList[i-1].url;
					}
				}
				if (this.verufy() != false) {
					this.$store.dispatch('SonClassifyValName', this.saveForm.moduleSonClassifyName)
					this.$store.dispatch('ClassifyValName', this.saveForm.moduleClassifyName)
					this.$store.dispatch('ModuleName', this.saveForm.moduleName)

					console.log(this.saveForm, 'this.saveForm.保存')
					editContent({
							data: this.saveForm
						})
						.then((response) => {
							this.value = 1;
							this.page = 1;
							this.pageSize = 10;
							this.getList()
						})
				}
			},
			// 取消
			cancel() {
				this.saveForm = {};
				console.log(this.saveForm)
				console.log(this.moduleIdList,'moduleIdList')
				this.value = 1;
				this.htmlLengthOver=false;
				// this.moduleData();
				this.getList()
			},
			quill(e) {
				this.htmlLength=e.quill.getLength()-1;
				if (this.htmlLength >= 10000) {
					this.htmlLengthOver = true;
				} else {
					this.htmlLengthOver = false;
				}
			},
			// 校验
			verufy() {
				if (this.showformList.length == 0) {
					this.$message.warning('未选择数据')
					return false;
				} else {
					if (this.saveForm.moduleClassifyId == undefined) {
						if (this.saveForm.moduleNameId != 7 && this.saveForm.moduleNameId != 9) {
							this.$message.error('模块分类未填写，请完整填写信息后提交')
							return false;
						}
					}
					for (var i = 0; i < this.showformList.length; i++) {
						if (this.saveForm[this.showformList[i]] == undefined || this.saveForm[this.showformList[i]] ==
							'') {
							if (this.showformList[i] == 'moduleClassifyName') {
								this.$message.error('图片位置未填写，请完整填写信息后提交')
								return false;
							} else if (this.showformList[i] == 'chnanelTypeName') {
								this.$message.error('客户端未填写，请完整填写信息后提交')
								return false;
							} else if (this.showformList[i] == 'theaterNum') {
								
							} else if (this.showformList[i] == 'repertoryNum') {
								this.$message.error('剧目数未填写，请完整填写信息后提交')
								return false;
							} else if (this.showformList[i] == 'viewerNum') {
								this.$message.error('观众数未填写，请完整填写信息后提交')
								return false;
							} else if (this.showformList[i] == 'title') {
								if(this.saveForm.moduleNameId!=7)
								{
									this.$message.error('标题未填写，请完整填写信息后提交')
									return false;
								}
							} else if (this.showformList[i] == 'leadName') {
								this.$message.error('领导名称未填写，请完整填写信息后提交')
								return false;
							} else if (this.showformList[i] == 'leadPost') {
								this.$message.error('领导职位未填写，请完整填写信息后提交')
								return false;
							} else if (this.showformList[i] == 'sort') {
								this.$message.error('排序未填写，请完整填写信息后提交')
								return false;
							} else if (this.showformList[i] == 'theaterName') {
								this.$message.error('剧院名称未填写，请完整填写信息后提交')
								return false;
							} else if (this.showformList[i] == 'email') {
								this.$message.error('邮箱未填写，请完整填写信息后提交')
								return false;
							} else if (this.showformList[i] == 'tell') {
								this.$message.error('电话号未填写，请完整填写信息后提交')
								return false;
							} else if (this.showformList[i] == 'adress') {
								this.$message.error('地址未填写，请完整填写信息后提交')
								return false;
							} else if (this.showformList[i] == 'publishTime') {
								if(this.saveForm.moduleNameId!=4)
								{
									this.$message.error('发布日期未填写，请完整填写信息后提交')
									return false;
								}
							} else if (this.showformList[i] == 'isRecommend') {
								this.$message.error('是否推荐未填写，请完整填写信息后提交')
								return false;
							} else if (this.showformList[i] == 'pictureUrl') 
							{
								console.log(this.saveForm.moduleClassifyId,'this.saveForm.moduleClassifyId')
								console.log(this.saveForm.moduleNameId,'modelue')
								if (this.saveForm.moduleClassifyId != '08') {
									if (this.saveForm.moduleNameId == 3) {
										
										if(this.fileList.length<=0)
										{
											this.$message.error('上传图片未填写，请完整填写信息后提交')
											return false;
										}
										
									} else {
										if(this.fileList.length<=0)
										{
											this.$message.error('上传图片未填写，请完整填写信息后提交')
											return false;
										}
									}
								}
							} else {
								this.$message.error('正文未填写，请完整填写信息后提交')
								return false;
							}
						}
					}
					if (this.saveForm.bodyContent != undefined) {
						if (this.saveForm.bodyContent.length > 10000) {
							this.$message.error('最大字符数为10000，请填写正确后提交')
							return false;
						}
					}
				}
			},

			theaterNumCheck(e) {
				console.log()
				if (!isNaN(e.currentTarget.value) && e.currentTarget.value > 0) {
					if (e.currentTarget.value > 9999) {
						this.$message.error('最大字符数为99999，请填写正确后提交')
						return false;
					}
				} else {
					this.$message.error('请输入正整数')
					return false;
				}
			},

			// 富文本传图片
			uploadSuccess(res) {
				if (this.saveForm.bodyContent == undefined) {
					this.saveForm.bodyContent = `<img src="${res.data}">`
				} else {
					let quill = this.$refs.QuillEditor.quill || this.$refs.QuillEditor[0].quill;//获取富文本编辑器dom对象
					let length = quill.getSelection().index;//光标位置
					quill.insertEmbed(length, "image", res.data); // 插入图片  图片地址
					quill.setSelection(length + 1);// 调整光标到最后 
				}
			},


			mouseover() {
				this.move = true;
			},
			mouseleave() {
				this.move = false;
			},
			moveClick() {
				this.saveForm.pictureUrl = '';
			},
			onExceed()
			{
				this.disabled=true;
			}
		}
	}
</script>

<style scoped lang="less">
	@import '../assets/table.css';
	.crumbs-boxContent {
		background-color: #F2F2F2;
		padding-left: 10px;
	}

	.crumbsContent {
		width: 100%;
		padding: 10px 0px 10px;
	}

	.selectboxContent {
		margin-top: 10px;
		margin-bottom: 20px;
	}
	.titleContent {
		line-height: 30px;
		text-align: right;
	}
	.leadPostRowItem{
		width: 100%;
		line-height: 30px;
	}
	.eleIconStyle {
		margin-top: 8px;
		font-size: 18px;
	}
	.eleIconStyle:hover {
		color: #5cb6ff;
		margin-top: 8px;
	}
	.addLeadPostBtn{
		width: 115px;
		height: 30px;
		cursor: default;
		display: flex;
		font-size: 14px;
		justify-content: center;
		align-items: center;
		border: 1px dashed rgb(92,182,255,0.5);
		i{
			margin: 2px 5px 0 0; font-size: 18px;
		}
		&:hover{
			color: #5cb6ff;
			border-color: #5cb6ff;
			i{margin: 2px 5px 0 0; font-size: 18px;}
		}
	}

	.selectContent {
		width: 100%;
		height: 30px;
		padding-left: 5px;
	}

	.formboxContent {
		background-color: #F2F2F2;
		padding-left: 10px;
		margin-top: 10px;
	}

	.tableboxContent {
		width: 98%;
		background-color: pink;
	}


	.table-trtitleContent {
		height: 50px;
		background-color: white;
		margin-top: 10px;
	}

	.sizeContent {
		margin-top: 10px;
		text-align: left;
	}

	.bodyContentInput {
		margin-top: 20px;
		height: 500px;
	}

	.htmlContent {
		width: 100%;
		height: 20px;
		line-height: 20px;
		text-align: left;
	}

	.htmlLengthOverTrue {
		color: red;
	}

	.htmlLengthOverFalse {
		color: black;
	}

	.head {
		max-width: 130px;
		min-height: 130px;
		height: 50px;
		cursor: pointer;
	}

	.imghover {
		width: 148px;
		height: 148px;
	}
	
	.must{
		color: red;
	}
	
	.kehuPC{
		float:left;
		line-height: 30px;
	}
	.kehuM{
		float:left;
		line-height: 30px;
	}
	.isnoPC{
		float:left;
		line-height: 30px;
	}
	.isnoM{
		float:left;
		line-height: 30px;
	}
	.el-date-editor.el-input, .el-date-editor.el-input__inner{
		float: left;
	}
</style>
